export default async (context) => {
    context.readyState = false

    context.videos = []

    await context.entry.forEach(item => {
        context.videos.push(item)
    })

    await context.main.forEach(item => {
        context.videos.push(item)
    })

    await context.ending.forEach(item => {
        context.videos.push(item)
    })

     context.videos = await context.videos.map((item) => ({
        status: false,
        playButton: true,
        ...item
    }))

    context.$store.dispatch('price/setPrice')

    context.$nextTick(() => {
        context.rendering = true
        context.readyState = true
    })
}